var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPilatesYogaAndMeditation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Yoga-Meditate--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Yoga Meditate Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.02 3a3 3 0 1 0 6 0 3 3 0 1 0 -6 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.46 9.73a1.5 1.5 0 0 0 -2.11 0.19C19 12.8 17.9 8.31 14.09 7.42a8.36 8.36 0 0 0 -4.18 0C6.05 8.55 5 12.7 2.65 9.92a1.5 1.5 0 1 0 -2.3 1.93c1 1.26 4.66 3.36 7.74 0.48a0.25 0.25 0 0 1 0.27 -0.05 0.25 0.25 0 0 1 0.15 0.23V17a0.51 0.51 0 0 0 0.34 0.47l2.81 1a1.06 1.06 0 0 0 0.66 0l2.82 -1a0.5 0.5 0 0 0 0.33 -0.47v-4.49a0.25 0.25 0 0 1 0.15 -0.23 0.25 0.25 0 0 1 0.27 0.05c3.09 2.88 6.69 0.78 7.74 -0.49a1.49 1.49 0 0 0 -0.17 -2.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.87 17.61 -3.7 1.31a0.25 0.25 0 0 0 -0.17 0.23 0.26 0.26 0 0 0 0.17 0.24l2.14 0.75a2.57 2.57 0 0 1 0.92 0.58 0.53 0.53 0 0 0 0.52 0.12l1.12 -0.4a1.5 1.5 0 0 0 -1 -2.83Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 21.09 -9.87 -3.48a1.5 1.5 0 0 0 -1 2.83L15 23.91a1.41 1.41 0 0 0 0.49 0.09 1.5 1.5 0 0 0 0.5 -2.91Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPilatesYogaAndMeditation);
export default ForwardRef;